import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { GridColDef, GridPinnedColumnFields } from '@mui/x-data-grid-pro';
import { ColumnDensity } from '@common/types';

export type PersistedReportFolderColumn = Pick<
  GridColDef,
  | 'field'
  | 'headerName'
  | 'width'
  | 'minWidth'
  | 'flex'
  | 'sortable'
  | 'filterable'
  | 'disableColumnMenu'
  | 'align'
  | 'headerAlign'
>;

export const initialReportFolderColumns: PersistedReportFolderColumn[] = [
  {
    field: 'favorite',
    headerName: '',
    width: 60,
    minWidth: 60,
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
  },
  {
    field: 'name',
    headerName: 'Name',
    minWidth: 200,
    flex: 1,
    sortable: true,
    filterable: false,
  },
  {
    field: 'created_at',
    headerName: 'Created at',
    minWidth: 160,
    flex: 1,
    sortable: true,
    filterable: false,
  },
  {
    field: 'organisation',
    headerName: 'Organization',
    minWidth: 160,
    flex: 1,
    sortable: false,
    filterable: false,
  },
  {
    field: 'updated_at',
    headerName: 'Updated at',
    minWidth: 160,
    flex: 1,
    sortable: true,
    filterable: false,
  },
  {
    field: 'report_count',
    headerName: 'Reports',
    minWidth: 120,
    flex: 1,
    sortable: true,
    filterable: false,
  },
  {
    field: 'private',
    headerName: '',
    width: 60,
    minWidth: 60,
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
  },
  {
    field: 'action',
    headerName: '',
    width: 60,
    minWidth: 60,
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
  },
];

export const initialReportFolderPinnedColumns: GridPinnedColumnFields = {
  left: [],
  right: [],
};

interface IReportFoldersTableDataGridStore {
  columns: PersistedReportFolderColumn[];
  setColumns: (columns: PersistedReportFolderColumn[]) => void;
  pinnedColumns: GridPinnedColumnFields;
  setPinnedColumns: (pinnedColumns: GridPinnedColumnFields) => void;
  hiddenColumns: string[];
  setHiddenColumns: (hiddenColumns: string[]) => void;
  density: ColumnDensity;
  setDensity: (density: ColumnDensity) => void;
  resetView: () => void;
}

export const useReportFoldersTableDataGridStore =
  create<IReportFoldersTableDataGridStore>()(
    persist(
      set => ({
        columns: initialReportFolderColumns,
        setColumns: columns => set({ columns }),
        pinnedColumns: initialReportFolderPinnedColumns,
        setPinnedColumns: pinnedColumns => set({ pinnedColumns }),
        hiddenColumns: [],
        setHiddenColumns: hiddenColumns => set({ hiddenColumns }),
        density: 'comfortable',
        setDensity: density => set({ density }),
        resetView: () =>
          set({
            columns: initialReportFolderColumns,
            pinnedColumns: initialReportFolderPinnedColumns,
            hiddenColumns: [],
            density: 'comfortable',
          }),
      }),
      {
        name: 'report-folders-table-datagrid-store',
        partialize: state => ({
          columns: state.columns,
          pinnedColumns: state.pinnedColumns,
          hiddenColumns: state.hiddenColumns,
          density: state.density,
        }),
      },
    ),
  );
